module.exports = __webpack_public_path__ + "img/family-history.939ebefb.svg";